// extracted by mini-css-extract-plugin
export var countryItem = "CountryButton-module--countryItem--6f317";
export var flag = "CountryButton-module--flag--eb6a8";
export var regionSwitcher = "CountryButton-module--regionSwitcher--98fcf";
export var toggleBtn = "CountryButton-module--toggleBtn--07e36";